import {
  makeStyles,
  mergeClasses,
  MessageBar,
  MessageBarBody,
  MessageBarGroup,
  MessageBarTitle,
  tokens,
} from "@fluentui/react-components";
import {
  DEFAULT_MAP_ERROR,
  MapErrorId,
  MAP_ERROR_CONFIG,
} from "../../utils/maps/MapConstants";

export interface IDisplayMapErrorsProps {
  messages: string[];
  className?: string;
}

export default function DisplayMapErrors({
  messages,
  className,
}: IDisplayMapErrorsProps) {
  const styles = useStyles();

  if (!messages.length) {
    return null;
  }

  return (
    <MessageBarGroup
      animate={"both"}
      className={mergeClasses(styles.messageBarGroup, className)}
    >
      {messages.map((id) => {
        const config = MAP_ERROR_CONFIG[id as MapErrorId] ?? DEFAULT_MAP_ERROR;

        return (
          <MessageBar key={id} intent={"error"}>
            <MessageBarBody>
              <MessageBarTitle>{config.errorMessage}</MessageBarTitle>
              {config.retryMessage}
            </MessageBarBody>
          </MessageBar>
        );
      })}
    </MessageBarGroup>
  );
}

const useStyles = makeStyles({
  messageBarGroup: {
    padding: tokens.spacingHorizontalMNudge,
    display: "flex",
    flexDirection: "column",
    marginTop: "3px",
    alignItems: "flex-end",
    gap: "10px",
    position: "relative",
    zIndex: 1000,
  },
});
